/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Table_GroupInputs */

const en_users_table_group = /** @type {(inputs: Users_Table_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groups`)
};

const pt_br2_users_table_group = /** @type {(inputs: Users_Table_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grupos`)
};

/**
* | output |
* | --- |
* | "Groups" |
*
* @param {Users_Table_GroupInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_table_group = /** @type {((inputs?: Users_Table_GroupInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Table_GroupInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_table_group(inputs)
	return pt_br2_users_table_group(inputs)
});